import React, { useState } from 'react';
import styled from 'App/styled';
import SortList from './sortList';
import ArrowIcon from 'components/Icons/Arrow';
import { trackSort } from 'helpers/filters/tracking';

const SortWrapper = styled.div`
  width: 100%;
  box-shadow: 0 1px 3px rgba(226, 226, 226, 0.25),
    0 1px 2px rgba(226, 226, 226, 0.5);
  border-radius: 4px;
  background: #fff;
  padding: 0 22px 0 12px;
`;
const Container = styled.div``;

const SortButton = styled.button`
  cursor: pointer;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  position: relative;
  display: flex;
  border-radius: 8px;
  align-items: center;
  ${({ theme }) => theme.typography.subTitleLarge};
  border: solid 1px white;
  padding: 14px 0;
  min-height: 1px;
  text-transform: capitalize;
  background: #fff;
  &.top {
    .arrow-icon {
      transform: rotate(180deg);
    }
  }
  .arrow-icon {
    fill: ${({ theme }) => theme.brandPrimary};
  }
`;

interface Props {
  sortOptions: { key: string; name: string }[];
  activeSort: string;
  changeSort: (sortKey: string) => void;
  pageName: string;
  pageTitle: string;
}

const DEFAULT_SORT = 'relevance_new';

const ListingSort = ({
  sortOptions,
  activeSort,
  changeSort,
  pageName,
  pageTitle,
}: Props) => {
  const [isSortOpen, setIsSortOpen] = useState(false);

  const closeModal = () => {
    setIsSortOpen(false);
  };

  const handleSort = () => {
    setIsSortOpen(!isSortOpen);
  };

  const onSelect = (sortOpt: { [key: string]: string }) => {
    const { key } = sortOpt || {};
    closeModal();
    changeSort(key);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    trackSort(key, { pageType: pageName, pageTitle });
  };

  let activeSortName = sortOptions.find((x) => x.key === activeSort)?.name;
  if (!activeSortName) {
    activeSortName = sortOptions.find((x) => x.key === DEFAULT_SORT)?.name;
    activeSort = DEFAULT_SORT;
  }
  const sortText = `Sort By : ${activeSortName}`;
  const buttonOpenClass = isSortOpen ? 'top' : '';
  return (
    <SortWrapper>
      <Container>
        <SortButton
          className={buttonOpenClass}
          onClick={handleSort}
          aria-expanded={isSortOpen}
        >
          <span className="sort-name">{sortText}</span>
          <ArrowIcon />
        </SortButton>
        {isSortOpen && (
          <SortList
            onSelect={onSelect}
            activeSort={activeSort}
            sortOptions={sortOptions}
          />
        )}
      </Container>
    </SortWrapper>
  );
};

export default ListingSort;
